import { render, staticRenderFns } from "./SelectResolution.vue?vue&type=template&id=732e151e&"
import script from "./SelectResolution.vue?vue&type=script&lang=js&"
export * from "./SelectResolution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports